module.exports = __webpack_public_path__ + "static/media/icon_data-alert.c7f2a9cd.svg";